
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  CustomsPackingModel,
  ProductInfoModel,
  PackingVolume,
  ProblemType,
} from "@/model/HenganLoadingPlanModels";
import Template from "@/views/system-management/template/index.vue";
import { uniqueArr } from "@/utils";
import { uniq } from "lodash";
import { deepClone } from "@/utils/deepClone";

/*配置柜型中的主包装列表*/
@Component({
  name: "CustomsPackingInfoInTable",
  components: { Template },
})
export default class extends Vue {

  @Prop({required: true}) private data: CustomsPackingModel[];
  @Prop({required: false}) private noLoaded: boolean;
  @Prop({required: false}) private tableName: string;
  @Prop({required: false, default: false}) private selectable: boolean;
  private data_: SimpleCustomsPackingInfoData[] = [];
  private isAllSelect = false;
  private quantities = "";
  private grossWeights = "";
  private netWeights = "";
  private volumes = "";
  private data_copy: SimpleCustomsPackingInfoData[] = [];

  @Watch("data", { deep: true, immediate: true })
  private watchData() {
    let convertArr: SimpleCustomsPackingInfoData[];
    let result: SimpleCustomsPackingInfoData[] = [];
    convertArr = this.convert();
    this.group(convertArr).map((value) => {
      if (value[0].groupId != null) {
        result.push(this.creatFatherSimpleCustomsPackingInfoData(value));
      } else {
        value.map((val) => {
          result.push(val);
        });
      }
    });
    this.data_ = result;
    this.data_copy = deepClone(this.data_)
    this.sum(result);
  }

  private convert() {
    return this.data?.map((value) => {
      let customsPackingInfo = new SimpleCustomsPackingInfoData();
      customsPackingInfo.id = value.id;
      customsPackingInfo.code = `${value.code.typeCode}${value.code.selfCode}#${value.code.serialNumber}`;
      const packingVolume = new PackingVolume(
        value.packingVolume.length,
        value.packingVolume.width,
        value.packingVolume.height
      );
      customsPackingInfo.volume = packingVolume.calculateVolume();
      customsPackingInfo.volumeNoDecimalProcessing = packingVolume.calculateVolumeNoDecimalProcessing();
      customsPackingInfo.grossWeight = value.packingWeight?.grossWeight;
      customsPackingInfo.netWeight = value.packingWeight?.netWeight;
      customsPackingInfo.henganPackingListCode = value.hqPackingListCode;
      customsPackingInfo.factoryName = value.factoryName;
      customsPackingInfo.problemType = value.problemType;
      customsPackingInfo.loadingFirst = value.loadingFirst;
      customsPackingInfo.declarationDescriptions = value.declarationDescriptions;
      customsPackingInfo.purchaseOrderNumbers = value.purchaseOrderNumbers;
      customsPackingInfo.inventory = value.inventory;
      if (this.noLoaded == null || !this.noLoaded){
        const productInfoModels: ProductInfoModel[] = value.secondaryPackingSet.map(value => value.packingInfos)
          .reduce((pre, cur) => pre.concat(cur), [])
          .map(value => value.productInfos)
          .reduce((pre, cur) => pre.concat(cur), []);
      customsPackingInfo.declarationDescriptions = uniqueArr(productInfoModels.map(p => p.declarationDescription)).join(",");
      customsPackingInfo.purchaseOrderNumbers = uniqueArr(productInfoModels.map(p => p.purchaseOrderNumber)).join(",");
      }
      customsPackingInfo.groupId = value.groupId;
      customsPackingInfo.containerNumber = value.containerNumber;
      return customsPackingInfo;
    });
  }

  private group = (sortData: SimpleCustomsPackingInfoData[]) => {
    const groupBy = (array: SimpleCustomsPackingInfoData[], f: Function) => {
      const groups: {
        [key: string]: SimpleCustomsPackingInfoData[];
      } = {};
      array.forEach((item) => {
        const group = JSON.stringify(f(item));
        groups[group] = groups[group] || [];
        groups[group].push(item);
      });
      return Object.keys(groups).map((group) => {
        return groups[group];
      });
    };
    const sorted = groupBy(sortData, (item: SimpleCustomsPackingInfoData) => {
      return item.groupId;
    });
    return sorted;
  };

  private creatFatherSimpleCustomsPackingInfoData(
    childrenCustomsPackingInfo: SimpleCustomsPackingInfoData[]
  ) {
    let simpleCustomsPackingInfoData = new SimpleCustomsPackingInfoData();
    let length = childrenCustomsPackingInfo.length;
    simpleCustomsPackingInfoData.id = childrenCustomsPackingInfo[0].id;
    if (length == 1) {
      simpleCustomsPackingInfoData.code = `${childrenCustomsPackingInfo[0].code}`;
    } else {
      simpleCustomsPackingInfoData.code = `${
        childrenCustomsPackingInfo[0].code
      } +${length - 1}箱`;
    }
    simpleCustomsPackingInfoData.volume = childrenCustomsPackingInfo[0].volume;
    simpleCustomsPackingInfoData.volumeNoDecimalProcessing = childrenCustomsPackingInfo[0].volumeNoDecimalProcessing;
    simpleCustomsPackingInfoData.grossWeight =
      childrenCustomsPackingInfo[0].grossWeight;
    simpleCustomsPackingInfoData.netWeight =
      childrenCustomsPackingInfo[0].netWeight;
    simpleCustomsPackingInfoData.henganPackingListCode =
      childrenCustomsPackingInfo[0].henganPackingListCode;
    simpleCustomsPackingInfoData.factoryName =
      childrenCustomsPackingInfo[0].factoryName;
    simpleCustomsPackingInfoData.declarationDescriptions =
      childrenCustomsPackingInfo[0].declarationDescriptions;
    simpleCustomsPackingInfoData.purchaseOrderNumbers =
      childrenCustomsPackingInfo[0].purchaseOrderNumbers;
    childrenCustomsPackingInfo.splice(0, 1);
    simpleCustomsPackingInfoData.children = childrenCustomsPackingInfo;
    // simpleCustomsPackingInfoData.inventory = childrenCustomsPackingInfo[0]?.inventory;
    // simpleCustomsPackingInfoData.hasChildren = false;
    return simpleCustomsPackingInfoData;
  }

  private handleSelectionChange(rows) {
    this.$emit("selection-change", rows);
  }

  // private handleSelectChange(params, first) {
  //   if(!first){
  //     this.isAllSelect = !this.isAllSelect;
  //   }
  //   this.handleSelectAll(params, this.isAllSelect);
  // }
  public getPackingNumberfilter() {
    let factoryNames: string[] = Array.from(
      new Set(this.data_.map((value) => value.henganPackingListCode))
    );
    let filterData = [];
    factoryNames.map((value) => {
      filterData.push({ text: value, value: value });
    });
    return filterData;
  }
  public packingListNumber(value, row) {
    return row.henganPackingListCode === value;
  }
  private handleGroupSelectAll(row) {
    if (this.isAllSelect && row.select === undefined) {
      row.select = false;
    } else if (row.select) {
      row.select = !row.select;
    } else {
      row.select = true;
    }
    this.handleGroupSelect(row, row.select);
  }

  private handleGroupSelect(row, flag) {
    const multipleTable = this.$refs.multipleTable as any;
    multipleTable.toggleRowSelection(row, flag);
    row.children.forEach((value) => {
      multipleTable.toggleRowSelection(value, flag);
    });
  }

  private handleSelectAll(data) {
    this.isAllSelect = !this.isAllSelect;
    data.map((el) => {
      this.toggleSelection(el, this.isAllSelect);
      if (el.children) {
        el.children.map((j) => {
          this.toggleSelection(j, this.isAllSelect);
        });
      }
    });
  }

  private toggleSelection(row, select) {
    const multipleTable = this.$refs.multipleTable as any;
    if (select) {
      multipleTable.toggleRowSelection(row, select);
    } else {
      multipleTable.clearSelection();
    }
  }

  private getContainerNumber() {
    let newArr = [];
    let newArrChilren = [];
    this.data_.map(ax => {
      if(ax.children) {
        newArrChilren = [...newArrChilren,...ax.children]
      }
    })
    newArr = [...this.data_,...newArrChilren]
    let factoryNames: string[] = Array.from(
      uniq(newArr.map((value) => value.containerNumber))
    );
    factoryNames = factoryNames.filter(function (s) {
        return s && s.trim(); 
    });
    let filterData = [];
    factoryNames.map((value) => {
      filterData.push({ text: value, value: value });
    });
    return filterData;
  }

  private getFactoryNameFilters() {
    let factoryNames: string[] = Array.from(
      new Set(this.data_.map((value) => value.factoryName))
    );
    let filterData = [];
    factoryNames.map((value) => {
      filterData.push({ text: value, value: value });
    });
    return filterData;
  }

  private filterFactoryName(value, row) {
    this.isAllSelect = false;
    return row.factoryName === value;
  }

  private filterChange(a) {
    if( a.filterContainerNumber && a.filterContainerNumber.length === 0) {
      this.data_ = deepClone(this.data_copy);
      this.sum(this.data_);
      let newArr = [];
      let newArrChilren = [];
      this.data_.map(ax => {
        if(ax.children) {
          newArrChilren = [...newArrChilren,...ax.children]
        }
      })
      newArr = [...this.data_,...newArrChilren];
      newArr.map(ax => {
        (this.$refs.multipleTable as any).toggleRowSelection(ax,false);
      })
    }
    if( a.filterContainerNumber && a.filterContainerNumber.length > 0) {
      this.isAllSelect = false;
      let newArr = [];
      let newArrChilren = [];
      a.filterContainerNumber.map(number => {
        this.data_.map(item => {
          if(item.children && item.children.length > 0) {
            if(item.containerNumber === number) {
              newArr.push(item);
            }
            item.children.map(child => {
              if(child.containerNumber === number) {
                newArrChilren.push(child);
              }
            })
          } else {
            if(item.containerNumber === number) {
              newArr.push(item);
            }
          }
        })
      })
      this.data_ = [...newArr,...newArrChilren];
      this.sum(this.data_);
      (this.$refs.multipleTable as any).toggleAllSelection();
    }
    if(a.filterArray) { // 工厂名称
      let filterData = this.data_.filter((value) => {
        if (
          a.filterArray.includes(value.factoryName) ||
          a.filterArray.length === 0
        ) {
          return value;
        }
      });
      this.sum(filterData);
    }
    if(a.numberArray) { // 装箱单号
      let filterData = this.data_.filter((value) => {
        if (
          a.numberArray.includes(value.henganPackingListCode) ||
          a.numberArray.length === 0
        ) {
          return value;
        }
      });
      this.sum(filterData);
    }
  }

  private sum(filterData: SimpleCustomsPackingInfoData[]) {
    let quantities = 0;
    let grossWeights = 0;
    let netWeights = 0;
    let volumes = 0;
    filterData.forEach((value) => {
      quantities = quantities + 1;
      grossWeights = grossWeights + Number(value.grossWeight);
      netWeights = netWeights + Number(value.netWeight);
      volumes += Number(value.volumeNoDecimalProcessing);
      if (value.children) {
        quantities = quantities + value.children.length;
        value.children.forEach((val) => {
          grossWeights = grossWeights + Number(val.grossWeight);
          netWeights = netWeights + Number(val.netWeight);
          volumes += Number(val.volumeNoDecimalProcessing);
        });
      }
    });
    this.quantities = quantities.toString();
    this.grossWeights = grossWeights.toFixed(2);
    this.netWeights = netWeights.toFixed(2);
    this.volumes = volumes.toFixed(2);
  }

  private updateStyle({ row, rowIndex }) {
    if (row.loadingFirst) {
      return "success-row";
    }
    return "";
  }
}

/**
 * 主包装信息
 */
export class SimpleCustomsPackingInfoData {
  id: string;
  loadingInfoId: string;
  factoryName: string;
  remark: string;
  henganPackingListCode: string;
  henganPackingListId: string;
  code: string;
  grossWeight: number;
  netWeight: number;
  volume: string;
  volumeNoDecimalProcessing: string;
  declarationDescriptions: string;
  purchaseOrderNumbers: string;
  problemType?: ProblemType;
  groupId: string;
  children: SimpleCustomsPackingInfoData[];
  select: boolean;
  loadingFirst: boolean;
  inventory: string;
  containerNumber: string;
}
